import React from 'react';
import { ApplicationForm } from 'components';

export function FormPage() {
  return (
    <ApplicationForm />
  );
}
